import { useQuery } from '@tanstack/react-query';
import { fetchSampleRecordStatuses, type SampleRecordStatus } from '../services/sampleRecordStatusService';

export const useSampleRecordStatuses = () => {
  const { data: sampleRecordStatuses = [], isLoading, error } = useQuery<SampleRecordStatus[]>({
    queryKey: ['sampleRecordStatuses'],
    queryFn: fetchSampleRecordStatuses,
    staleTime: 5 * 60 * 1000, // 5 minutos
    retry: 3,
  });

  return { sampleRecordStatuses, isLoading, error };
}; 